import React, { useState } from 'react';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import TaskTools from './TaskTools';

const TaskToolsMenu = ({
  category,
  listItem = false,
  task,
  upward,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <StandardToolsMenu
      listItem={listItem}
      onChange={setOpen}
      open={open}
      upward={upward}
    >
      {open && (<TaskTools category={category} task={task} />)}
    </StandardToolsMenu>
  );
};

export default TaskToolsMenu;
